<template>
    <div style="background-color: white">
        <div class="navTab">
            <div class="navItem">
                <div class="flex justify-between">
                    <div class="flex align-center hidden kdship " >
                        <li class="text-left navtitle cursor-pointer"  :class="item.type?'navtitle1':''" v-for="(item,i) in navData" :key="i" @click="checkTab(item.id,i)">{{item.name}}</li>
                    </div>
                    <div class="flex align-center">
<!--                        <li class="xiala">最新项目</li>-->
<!--                        <li class="xiala">全部分类</li>-->
                        <el-dropdown @command="sortClass">
                            <el-button class="phone-dropdown" style="padding: 17px 20px;">
                                最新项目<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown" :split-button="true">
                                <el-dropdown-item :command="1">人气项目</el-dropdown-item>
                                <el-dropdown-item :command="0">最新项目</el-dropdown-item>
<!--                                <div class="dropdownis" @click="listByCategory(0,1,10,1)">人气项目</div>-->
<!--                                <div class="dropdownis" @click="listByCategory(0,1,10,0)">最新项目</div>-->
<!--                                <el-dropdown-item @click="listByCategory(0,1,10,1)">人气最新</el-dropdown-item>-->
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-dropdown trigger="click" @command="handleCommand">
                            <el-button @click="zezao = !zezao" style="padding: 17px 20px;box-shadow: -9px 0px 9px 0px white;">
<!--                            <el-button @click="dropdownMenu = !dropdownMenu">-->
                                全部分类<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu class="phone-classbotton">

                                <div class="clasSele">
                                    <el-dropdown-item :command="i" :class="item.type?'clasSeleColor':''" class="clasSeleItem1" v-for="(item,i) in navData" :key="i">{{item.name}}</el-dropdown-item>
<!--                                    <li class="fl clasSeleItem" :class="item.type?'clasSeleColor':''" @click="dropdownClick(i)" v-for="(item,i) in navData" :key="i">{{item.name}}</li>-->
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </div>
<!--        遮罩-->
        <div @click="zezao = !zezao" class="zezao" style="background-color:  rgba(60, 60, 67, 0.6);height: 100%;width: 100%; position: absolute;z-index: 10;" v-show="zezao"></div>

        <!--        全景数据-->
        <vr-item style="margin-top: 15px;padding-bottom: 15px" :vrInfo="vr_info"></vr-item>
        <div v-if="vr_info.length===0" >
            <nullPage style="padding: 150px 0;"></nullPage>
        </div>
<!--        分页-->
        <el-pagination class="phone-pagination" style="padding-top:20px;padding-bottom: 40px"
                background @current-change="current_change"
                       :page-size="1"
                layout="prev, pager, next, jumper"
                :total="maxPage">
        </el-pagination>

    </div>
</template>

<script>

    import vrItem from '@/components/vr-item-class'
    import nullPage from "@/components/nullPage";
    export default {
        name: "classify",
        components: {
            vrItem,nullPage
        },
        data() {
            const vrItem={
                vrimg:'http://browser9.qhimg.com/bdm/480_296_0/t01cd97ec806b712059.jpg',
                title:'望谟县大观镇伏开村全景图',
                id:'GYNJS234234',
                address:'贵州省黔西南州望谟县大关乡上伏开村一组',
                see:'255',praise:'254'
            }
            return {
                zezao:false,
                currentPage3: 5,
                isNav:true,
                // 分类
                navData: [{id:0,name:'全部分类',type:true}],
                // navData:[{title:'全部分类',type:true},{title:'房屋类',type:false},{title:'土地类',type:false},{title:'林木类',type:false},{title:'其他类',type:false}],
                // // 分类
                // selectData:[
                //     '全部分类',
                //     '林权',
                //     '农村集体资产股权',
                //     '农村集体资产股权',
                //     '农户房屋所有权和使用权',
                //     '农户房屋所有权和使用权',
                //     '农户房屋所有权和使用权',
                //     '“四荒”地使用权',
                //     '农场土地经营权',
                //     '小型水利设施使用权',
                // ],
                vr_info:[],
                // vr_info:Array(25).fill(vrItem),
                dropdownMenu:true,
                maxPage:0, // 分页
                classId:0, // 当前分类id值→分页请求用
                DataStatus:true, // 下滑数据是否请求完
                xialaPage:1, // 下拉请求页
            }
        },
        created() {
            this.listByCategory(0,1,25,0) // 全部列表
            this.getAategorList()
            this.main()
        },
        methods: {
            // 排序
            sortClass(e){
                this.listByCategory(this.classId,1,25,e) // 全部列表
            },
            // 切换控制
            handleCommand(i) {
                console.log('chage',this.navData[i].id+'||'+i)
                this.xialaPage = 1
                this.zezao = false
                // this.$message('click on item ' + i);
                this.navData[i].type = true
                this.checkTab(this.navData[i].id,i)
                for(var j = 0;j < this.navData.length;j++){
                    if(j === i){
                        continue ;
                    }
                    this.navData[j].type = false;
                }
                // this.current_change(1)
                // this.listByCategory(this.navData[i].id,1,25,0)
            },
            // 切换控制分类
            checkTab(id,i){
                this.xialaPage = 1
                this.navData[i].type = true
                this.classId = id
                for(var j = 0;j < this.navData.length;j++){
                    if(j === i){
                        continue ;
                    }
                    this.navData[j].type = false;
                }
                this.current_change(1)
                // this.listByCategory(id,1,25,0)
            },
            // 推荐项目分类
            getAategorList(){
                this.$http({
                    url: this.$Api.AategorList,
                    params:{
                        page:1,           // 默认1
                        pageSize:50      // 默认10
                    }
                }).then((res)=>{
                    res.data.forEach((item,index)=>{
                        this.navData.push({
                            id: item.id,
                            name: item.name,
                            type: false
                        })
                    })
                    console.log('分类页',res.data)
                })
            },
            // 获取项目item
            listByCategory(categoryId,page,pageSize,sortType){
                this.$http({
                    url: this.$Api.listByCategory,
                    params: {
                        categoryId:categoryId,
                        page:page,
                        pageSize:pageSize,
                        sortType:sortType
                    }
                }).then(res=>{
                    this.maxPage = res.count
                    this.vr_info = res.data
                    console.log('全部项目',res)
                })
            },
            // 分页
            current_change(e){
                console.log('分页',e)
                this.listByCategory(this.classId,e,25,0) // 全部列表
            },
            // 监听浏览器滚动事件
            main() {
                console.log('main')
                // var app = document.getElementsByClassName('el-main')
                //addEventListener适用于版本较新的IE浏览器 ，如IE9以及火狐浏览器，
                document.addEventListener("mousewheel", this.MouseWheelHandler, false);
                // Firefox浏览器使用的滚轮事件是 DOMMouseScroll
                document.addEventListener("DOMMouseScroll", this.MouseWheelHandler, false);
                document.addEventListener('scroll', this.MouseWheelHandler, true);
            },
            // 获得滚动的值
            MouseWheelHandler() {
                let scrollTop = 0;
                if (document.documentElement && document.documentElement.scrollTop) {
                    scrollTop = document.documentElement.scrollTop;
                } else if (document.body) {
                    scrollTop = document.body.scrollTop;
                }
                // console.log('scrollTop',document.body.scrollHeight || document.documentElement.scrollHeight)
                // console.log('clientHeight',document.documentElement.clientHeight || document.body.scrollHeight)
                let  scrollHeight = document.body.scrollHeight || document.documentElement.scrollHeight
                let  clientHeight = document.documentElement.clientHeight || document.body.clientHeight
                console.log(scrollTop)
                if(window.screen.width < 768){
                    if(scrollHeight+clientHeight >= scrollTop){
                        if(this.DataStatus){
                            this.phonelistByCategory(this.xialaPage++,25,1)
                        }else {
                            // this.$message('已经没有数据了');
                        }
                    }
                }
            },
            phonelistByCategory(page,pageSize,sortType){
                this.$http({
                    url: this.$Api.listByCategory,
                    params: {
                        categoryId:this.classId,
                        page:page,
                        pageSize:pageSize,
                        sortType:sortType
                    }
                }).then(res=>{
                    if(res.data.length > 0){
                        this.vr_info.push(res.data)
                    }else{
                        this.DataStatus = false
                    }
                    console.log('s全部项目',res)
                })
            },
            handleClick() {
                // alert('button click');
            },
        },
        beforeDestroy() {
            document.removeEventListener("mousewheel", this.MouseWheelHandler);
            document.removeEventListener("DOMMouseScroll", this.MouseWheelHandler);
            document.removeEventListener("scroll", this.MouseWheelHandler);
        }
    }
</script>

<style scoped>

    .el-button:focus, .el-button:hover {
        color: #ff5c38;
        border-color: #ecf5ff;
        background-color: #fff;
    }
    .el-dropdown-menu__item:hover{
        color: #ff5c38;
    }
    .el-button{
        padding: 15px 20px;
    }
    li{list-style: none;}
    .navTab {
        width: 100%;
        border-bottom: 1px #eaede5 solid;
        height: 50px;
    }

    .navItem {
        max-width: 1180px;
        /*background-color: #939393;*/
        margin: 0 auto;
        height: inherit;
    }
    .navtitle{
        font-size: 14px;
        color: #000000;
        text-align: left;
        margin-right: 15px;
        padding-top: 15px;
        height: 35px;
        border-radius: 2px;
        border-bottom: 2px rgba(255,255,255,0) solid;
        white-space: nowrap;
    }
    .navtitle:hover{
        color: #ff5c38;
    }
    .navtitle1{
        color: #ff5c38;
        border-bottom: 2px rgba(255,96,56,1) solid;
    }
    .xiala{
        height: 50px;
        width: 120px;
        border-bottom: 1px #eaede5 solid;
        border-left: 1px #eaede5 solid;
        border-right: 1px #eaede5 solid;
    }
    .clasSele{
        /*height: 200px;*/
        width: 396px;
    }
    .clasSeleItem{
        /*background-color: rgba(241,241,241,1);*/
        padding: 5px 10px;
        margin: 5px;
        border-radius: 50px;
        font-size: 14px!important;
    }
    .clasSele>li:hover{
        color: #ff5c38;
    }
    .clasSeleColor{
        color: #ff5c38;
    }
    .dropdownis{
        padding: 10px 20px;
        text-align: center;
        cursor: default;
    }
    .dropdownis:hover{
        background-color: #ecf5ff;
        color: #639ad7;
    }
    .kdship{
        max-width: 910px;
        /*background-color: #ff5c38;*/
        overflow: hidden;
    }
    .el-dropdown-menu__item:hover{
        background-color: #fff!important;
    }
    .clasSeleItem1{
        padding: 5px 10px;
        margin: 5px;
        border-radius: 50px;
        line-height: unset;
        float: left;font-size: 14px!important;
    }
    .clasSeleItem1:hover{
        background-color: #ff5c38;
    }
    @media only screen and (max-width: 568px) {
        /*.phone-classbotton{*/
        /*    left: 4px!important;*/
        /*}*/
        .clasSele{
            max-width: 350px;
        }
    }
    @media only screen and (max-width: 992px) {
        /*.phone-pagination, .phone-dropdown{*/
        /*    display: none !important;*/
        /*}*/


        .kdship{
            max-width: 290px;
            overflow: hidden;
        }
        .clasSeleItem{
            background-color: rgba(241,241,241,1);
        }
        .clasSeleItem1 {
            background-color: rgba(241,241,241,1);
        }
    }
    @media only screen and (min-width: 768px){
        .zezao{
            display: none;
        }
    }
</style>